import { AxiosError } from "axios"
import { useQuery } from "react-query"
import { getEmployeeUtilization, getFilteredSoldJobRevenue, getFilteredWonLost, getFinancialsData, getSalesLeads, getSoldJobRevenue, getWonLost } from "./dashboardApi"
import { DashboardFilters } from "./dashboardModel"

// Without filters (dashboard-reporting off) this is exactly the original query.
export const useSoldJobRevenue = (start: string, end: string, filters?: DashboardFilters) => {
  return useQuery(
    filters ? ['filtered-sold-job-revenue', { start, end, filters }] : ['sold-job-revenue', { start, end }],
    () => filters ? getFilteredSoldJobRevenue(start, end, filters) : getSoldJobRevenue(start, end),
    { refetchOnWindowFocus: false, 
      enabled: !!start && !!end 
    },
  )
}

export const useSalesLeads = (start: string, end: string) => {
  return useQuery(
    ['sales-leads', { start, end }],
    () => getSalesLeads(start, end),
    { refetchOnWindowFocus: false, 
      enabled: !!start && !!end 
    },
  )
}

// Without filters (dashboard-reporting off) this is exactly the original query.
export const useWonLost = (start: string, end: string, filters?: DashboardFilters) => {
  return useQuery(
    filters ? ['filtered-won-lost', { start, end, filters }] : ['won-lost', { start, end }],
    () => filters ? getFilteredWonLost(start, end, filters) : getWonLost(start, end),
    { refetchOnWindowFocus: false, 
      enabled: !!start && !!end 
    },
  )
}

export const useFinancialsData = (start: string, end: string, filters: DashboardFilters) => {
  return useQuery(
    ['financials-data', { start, end, filters }],
    () => getFinancialsData(start, end, filters),
    { refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!start && !!end
    },
  )
}

// Takes the narrowed filters, so the key, the request and the card's notice all use the same value.
export const useEmployeeUtilization = (start: string, end: string, appliedFilters: DashboardFilters) => {
  return useQuery(
    ['employee-utilization', { start, end, filters: appliedFilters }],
    () => getEmployeeUtilization(start, end, appliedFilters),
    { refetchOnWindowFocus: false,
      // 404 means the API has dashboard-reporting off for this tenant; retrying only delays the error.
      retry: (failureCount, error: AxiosError) => error?.response?.status !== 404 && failureCount < 3,
      enabled: !!start && !!end
    },
  )
}
